import { useUserQuery } from 'generated/graphql';
import { getAccessToken, setLoggedInUserSubId } from 'helpers/auth';
import { analyticsClient } from '@spotted-zebra-uk/ui-components';
import { APP_NAME } from 'constants/analytics';

const UserWrapper = ({ children }: { children: React.ReactNode }) => {

  const accessToken = getAccessToken();

  useUserQuery({
    fetchPolicy: 'network-only',
    skip: !accessToken,
    onCompleted: data => {
      const userSubId = data.User.subId;
      if (userSubId) {
        analyticsClient.setAnalyticsContext({
          user: {
            subId: userSubId,
            roles: data.User.roles,
            isInternal: data.User.isInternal,
          },
          includeActorRoleProperties: false,
          appName: APP_NAME,
        });

        setLoggedInUserSubId(userSubId)
      }
    },
    onError: console.error,
  });

  return <>{children}</>;
};

export default UserWrapper;
